import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
const _excluded = ["children", "style"],
  _excluded2 = ["boxShadow", "backgroundColor", "borderRadius"],
  _excluded3 = ["isSelected"];
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import Avatar from '@adsk/alloy-react-avatar';
import { MenuGroupHeader, MenuItem, isGroupHeader } from '@adsk/alloy-react-dropdown';
import Footer, { ClearButton } from '@adsk/alloy-react-footer';
import { BuildingFilledIcon, BuildingIcon, PeopleFilledIcon, PeopleIcon, PersonIcon } from '@adsk/alloy-react-icon';
import Theme from '@adsk/alloy-react-theme';
import { ASSIGNEE_PICKER_COMPANY, ASSIGNEE_PICKER_ROLE, ASSIGNEE_PICKER_USER } from '../consts';
export const defaultValueTagRenderer = function (item) {
  let {
    showIcons,
    showGroupCountInTags,
    renderIcon
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const isItemOfGroupType = [ASSIGNEE_PICKER_COMPANY, ASSIGNEE_PICKER_ROLE].includes(item === null || item === void 0 ? void 0 : item.group);
  let label = item ? item.label : '';
  if (showGroupCountInTags && isItemOfGroupType && !!(item !== null && item !== void 0 && item.subtext)) {
    label += " (".concat(item === null || item === void 0 ? void 0 : item.subtext, ")");
  }
  if (showIcons) {
    var _renderIcons$item$gro;
    const renderIcons = {
      [ASSIGNEE_PICKER_COMPANY]: p => /*#__PURE__*/React.createElement(BuildingIcon, p),
      [ASSIGNEE_PICKER_ROLE]: p => /*#__PURE__*/React.createElement(PeopleIcon, p),
      [ASSIGNEE_PICKER_USER]: p => /*#__PURE__*/React.createElement(PersonIcon, p)
    };
    const iconBaseStyle = {
      size: 17,
      style: {
        margin: '0 5px -3px 3px'
      }
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderIcon ? renderIcon(iconBaseStyle) : (_renderIcons$item$gro = renderIcons[item.group]) === null || _renderIcons$item$gro === void 0 ? void 0 : _renderIcons$item$gro.call(renderIcons, iconBaseStyle), label);
  } else {
    return label;
  }
};
export const defaultFooterRenderer = _ref => {
  let {
    clearable,
    isOpen,
    hasSelectedItems,
    setSelectedItems
  } = _ref;
  return clearable && isOpen && hasSelectedItems && /*#__PURE__*/React.createElement(Footer, null, /*#__PURE__*/React.createElement(ClearButton, {
    "data-testid": "assignee-picker-clear-button",
    onClick: () => setSelectedItems([])
  }));
};
export const renderWrapper = _ref2 => {
  let {
    parentRef,
    isOpen,
    setSelectedItems,
    clearable,
    hasSelectedItems,
    renderVirtualizedMenuFooter,
    totalSize
  } = _ref2;
  const wrapper = _ref3 => {
    let {
        children,
        style
      } = _ref3,
      wrapperProps = _objectWithoutProperties(_ref3, _excluded);
    const _ref4 = style,
      {
        boxShadow,
        backgroundColor,
        borderRadius
      } = _ref4,
      rest = _objectWithoutProperties(_ref4, _excluded2);
    return /*#__PURE__*/React.createElement(_StyledDiv, {
      $_css: [{
        boxShadow,
        backgroundColor,
        borderRadius
      }]
    }, /*#__PURE__*/React.createElement(_StyledDiv2, _extends({
      ref: parentRef
    }, wrapperProps, {
      $_css2: [rest]
    }), /*#__PURE__*/React.createElement(_StyledDiv3, {
      $_css3: [{
        height: totalSize
      }]
    }, children)), renderVirtualizedMenuFooter({
      clearable,
      isOpen,
      hasSelectedItems,
      setSelectedItems
    }));
  };
  return wrapper;
};
export const getMenuStyle = _ref5 => {
  let {
    isOpen,
    isLoading
  } = _ref5;
  return _objectSpread(_objectSpread({}, isOpen && {
    minHeight: '32px'
  }), isOpen && isLoading && {
    minHeight: '56px'
  });
};
const getVirtualizedItemStyle = _ref6 => {
  let {
    size,
    start
  } = _ref6;
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: size,
    transform: "translateY(".concat(start, "px)"),
    display: 'flex',
    alignItems: 'center'
  };
};
export const defaultAvatarLeftComponent = _ref7 => {
  var _renderFallbackIcon;
  let {
    item
  } = _ref7;
  const isItemRole = (item === null || item === void 0 ? void 0 : item.group) === ASSIGNEE_PICKER_ROLE;
  const isItemCompany = (item === null || item === void 0 ? void 0 : item.group) === ASSIGNEE_PICKER_COMPANY;
  const isImageLessGroup = !(item !== null && item !== void 0 && item.imageUrl) && (isItemRole || isItemCompany);
  const renderFallbackIcon = {
    [ASSIGNEE_PICKER_COMPANY]: p => /*#__PURE__*/React.createElement(BuildingFilledIcon, p),
    [ASSIGNEE_PICKER_ROLE]: p => /*#__PURE__*/React.createElement(PeopleFilledIcon, p)
  };
  return /*#__PURE__*/React.createElement(Avatar, {
    size: Avatar.SIZES.MEDIUM_24,
    name: item === null || item === void 0 ? void 0 : item.label,
    imageUrl: item === null || item === void 0 ? void 0 : item.imageUrl,
    style: _objectSpread({
      marginRight: '8px'
    }, isImageLessGroup ? {
      background: Theme.colors.charcoal100,
      color: Theme.colors.charcoal500
    } : {})
  }, (_renderFallbackIcon = renderFallbackIcon[item === null || item === void 0 ? void 0 : item.group]) === null || _renderFallbackIcon === void 0 ? void 0 : _renderFallbackIcon.call(renderFallbackIcon, {
    size: 16
  }));
};
export const defaultMenuItemRenderer = _ref8 => {
  let {
    item,
    isGroupHeader,
    index,
    size,
    start,
    getItemProps,
    renderLeftComponent,
    showAvatars,
    removeSelectedItem,
    addSelectedItem
  } = _ref8;
  const avatarRenderer = showAvatars ? () => defaultAvatarLeftComponent({
    item
  }) : undefined;
  if (isGroupHeader(item)) {
    return /*#__PURE__*/React.createElement(MenuGroupHeader, {
      key: index,
      style: getVirtualizedItemStyle({
        size,
        start
      })
    }, item.label);
  } else {
    const _getItemProps = getItemProps === null || getItemProps === void 0 ? void 0 : getItemProps({
        item
      }),
      {
        isSelected
      } = _getItemProps,
      itemProps = _objectWithoutProperties(_getItemProps, _excluded3);
    return /*#__PURE__*/React.createElement(MenuItem, _extends({
      key: index,
      "data-testid": "assignee-picker-menu-item-".concat(index)
    }, itemProps, {
      style: getVirtualizedItemStyle({
        size,
        start
      }),
      isSelected: isSelected,
      renderLeftComponent: renderLeftComponent || avatarRenderer
    }, addSelectedItem && removeSelectedItem ? {
      onClick: () => {
        isSelected ? removeSelectedItem(item) : addSelectedItem(item);
      }
    } : {}));
  }
};
export const defaultVirtualizedItemsRenderer = _ref9 => {
  let {
    rowVirtualizer,
    groupedMenuItems,
    isGroupHeader,
    getItemProps,
    renderLeftComponent,
    renderMenuItem,
    showAvatars,
    removeSelectedItem,
    addSelectedItem
  } = _ref9;
  return rowVirtualizer.virtualItems.map(_ref10 => {
    let {
      index,
      size,
      start
    } = _ref10;
    return renderMenuItem({
      index,
      item: groupedMenuItems[index],
      size,
      start,
      isGroupHeader,
      getItemProps,
      renderLeftComponent,
      showAvatars,
      removeSelectedItem,
      addSelectedItem
    });
  });
};
export const defaultGetFilteredItems = _ref11 => {
  let {
    allItems,
    inputValue = ''
  } = _ref11;
  const search = inputValue.trim().toLowerCase();
  if (!search) return allItems;
  return allItems.filter(item => {
    const {
      label,
      subtext
    } = item;
    return label && label.toLowerCase().indexOf(search) >= 0 || subtext && subtext.toLowerCase().indexOf(search) >= 0;
  });
};
export const getFilteredMenuItems = _ref12 => {
  let {
    items,
    idsToHide
  } = _ref12;
  return idsToHide !== null && idsToHide !== void 0 && idsToHide.size ? items.filter(item => isGroupHeader(item) || !idsToHide.has(item.value)) : items;
};
export const sortUsersAlphabetically = items => items.sort((a, b) => a.name.localeCompare(b.name));
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), p => p.$_css2);
var _StyledDiv3 = _styled3("div").withConfig({
  displayName: "utils___StyledDiv3",
  componentId: "sc-t156ak-0"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=utils.js.map